import { render, staticRenderFns } from "./_fieldGroup.vue?vue&type=template&id=0bb8630a&"
import script from "./_fieldGroup.vue?vue&type=script&lang=js&"
export * from "./_fieldGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports